<div
  style="display: flex; flex-direction: column"
  class="fullheight"
  [ngStyle]="{ 'font-size.px': globalService.isMobileDevice ? '20' : '30' }"
  autoCloseTimer
>
  <div style="display: flex; flex-direction: row; flex-wrap: wrap" class="header" *ngIf="isHome">
    <mat-toolbar class="top-toolbar">
      <mat-toolbar-row class="top-toolbar-color">
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            flex: 1 1 auto;
          "
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <a
              routerLink="/home"
              style="display: flex; flex-direction: row; justify-content: center; align-items: center"
            >
              <img
                *ngIf="!globalService.isMobileDevice"
                [src]="globalService.logotipoCantoSuperiorEsquerdo"
                alt="Seguros Virtual"
                width="220"
                height="66"
                (click)="globalService.FullMenu = false; scrollToTop()"
              />
              <img
                *ngIf="globalService.isMobileDevice"
                [src]="globalService.logotipoCantoSuperiorEsquerdo"
                alt="Seguros Virtual"
                width="160"
                height="48"
                (click)="globalService.FullMenu = false; scrollToTop()"
              />
            </a>
          </div>

          <div *ngIf="globalService.loggedUserClass?.Admin" style="display: flex; flex-direction: row">
            <app-activeadmin></app-activeadmin>
          </div>

          <div
            *ngIf="isUserLoggedIn && globalService.loggedUserClass"
            style="
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;
              margin-right: 5px;
            "
          >
            <div style="position: relative; display: inline-block">
              <app-user-avatar
                [photoPath]="
                  globalService.loggedUserClass?.customerClass?.Photo ||
                  globalService.loggedUserClass?.commercialClass?.Photo
                    ? (globalService.loggedUserClass?.customerClass?.Photo ||
                        globalService.loggedUserClass?.commercialClass?.Photo | convertImageToUrl)
                    : null
                "
                [userName]="
                  globalService.loggedUserClass?.customerClass?.firstLastName ||
                  globalService.loggedUserClass?.customerClass?.Name ||
                  globalService.loggedUserClass?.commercialClass?.Name ||
                  globalService.loggedUserClass?.Nome ||
                  ''
                "
                size="header"
                (click)="globalService.FullMenu = false; scrollToTop(); toggleUserMenu()"
                style="cursor: pointer"
              ></app-user-avatar>

              <!-- Badge de Alertas no menu completo -->
              <div
                *ngIf="userAlertsCount > 0"
                style="
                  position: absolute;
                  top: -4px;
                  right: -4px;
                  background-color: #f44336;
                  color: white;
                  border-radius: 50%;
                  min-width: 18px;
                  height: 18px;
                  font-size: 11px;
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  border: 2px solid white;
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                  z-index: 10;
                  padding: 0 4px;
                "
                (click)="
                  $event.stopPropagation();
                  globalService.FullMenu = false;
                  alertsService.showAlerts(globalService.loggedUserClass?.customerClass?.alertUser, '');
                  scrollToTop();
                  toggleUserMenu()
                "
                matTooltip="Tem {{ userAlertsCount }} alertas pendentes"
              >
                {{ userAlertsCount }}
              </div>
            </div>

            <i
              *ngIf="!globalService.FullMenu"
              (click)="openFullMenu(); scrollToTop()"
              style="cursor: pointer; margin-left: 35px; color: #ffffff; font-size: 30px"
              class="fa fa-bars"
              aria-hidden="true"
              [title]="'MENU.OPEN' | translate"
            ></i>

            <i
              *ngIf="globalService.FullMenu"
              (click)="openFullMenu(); scrollToTop()"
              style="cursor: pointer; margin-left: 35px; color: #ffffff; font-size: 35px"
              class="fa fa-times"
              aria-hidden="true"
              [title]="'MENU.CLOSE' | translate"
            ></i>
          </div>

          <div
            *ngIf="!isUserLoggedIn"
            style="
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;
              margin-right: 5px;
              font: 13px;
            "
          >
            <img
              style="cursor: pointer; font-size: medium; color: #000000"
              src="assets/icons/Logout.webp"
              (click)="globalService.FullMenu = false; scrollToTop(); authService.logout()"
              [alt]="'MENU.SIGN_OUT' | translate"
            />

            <i
              [style.visibility]="'hidden'"
              style="margin-left: 35px; font-size: 30px"
              class="fa fa-bars"
              aria-hidden="true"
            ></i>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>

  <div style="display: flex; flex: 1 1 auto; flex-direction: column; justify-content: center; align-items: center">
    <ul style="list-style-type: none; padding: 0; text-align: center">
      <li>
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          routerLink="/clientarea"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          {{ 'MENU.CLIENT_AREA' | translate }}
        </a>
      </li>

      <li
        *ngIf="
          (globalService.loggedUserClass?.IntermediaryArea ||
            globalService.loggedUserClass?.Admin) &&
          isUserLoggedIn
        "
      >
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          [routerLink]="'/intermediaryarea'"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          {{ 'MENU.INTERMEDIARY_AREA' | translate }}
        </a>
      </li>

      <li>
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          routerLink="/home"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          {{ 'MENU.HOME' | translate }}
        </a>
      </li>

      <li>
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          routerLink="/home"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          {{ 'MENU.SIMULATE' | translate }}
        </a>
      </li>

      <li *ngIf="isUserLoggedIn">
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          routerLink="clientarea/fullinsurancepolicy"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          {{ 'MENU.MY_POLICIES' | translate }}
        </a>
      </li>

      <li *ngIf="isUserLoggedIn">
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          routerLink="clientarea/fullinsuranceclaims"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          {{ 'MENU.CLAIMS' | translate }}
        </a>
      </li>

      <li>
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          routerLink="/guias"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          Blog
        </a>
      </li>

      <!-- Links de Sobre e Contactos removidos temporariamente - Info disponível no footer -->

      <li
        *ngIf="
          (globalService.loggedUserClass?.SiteManagement || globalService.loggedUserClass?.Admin) && isUserLoggedIn
        "
      >
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          [routerLink]="'/admin'"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          Configurações
        </a>
      </li>

      <li *ngIf="showCRM && isUserLoggedIn">
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          [routerLink]="'/crm'"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          CRM ADM
        </a>
      </li>

      <li *ngIf="showCRMMediador && isUserLoggedIn">
        <a
          style="text-decoration: none; cursor: pointer; color: white"
          [routerLink]="'/crm-mediador'"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          CRM Mediadores
        </a>
      </li>

      <li *ngIf="isUserLoggedIn && globalService.loggedUserClass?.Admin">
        <a
          style="text-decoration: none; cursor: pointer; color: #21f0b5; font-weight: 700"
          [routerLink]="'/telemedicina'"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          Rede Médica &amp; Telemedicina
        </a>
      </li>

      <li
        *ngIf="
          isUserLoggedIn && (globalService.loggedUserClass?.Admin || globalService.loggedUserClass?.AdminMarketing)
        "
      >
        <a
          routerLink="/sendinvitations"
          style="text-decoration: none; cursor: pointer; color: white"
          queryParamsHandling="preserve"
          (click)="onLinkClick()"
        >
          {{ 'MENU.SEND_INVITATION' | translate }}
        </a>
      </li>

      <li>
        <a
          *ngIf="isUserLoggedIn"
          (click)="globalService.FullMenu = false; authService.logout()"
          style="text-decoration: none; cursor: pointer; color: white"
          queryParamsHandling="preserve"
        >
          {{ 'MENU.SIGN_OUT' | translate }}
        </a>

        <a
          *ngIf="!isUserLoggedIn"
          (click)="globalService.FullMenu = false; authService.logout()"
          style="text-decoration: none; cursor: pointer; color: white"
          queryParamsHandling="preserve"
        >
          {{ 'MENU.SIGN_IN' | translate }}
        </a>
      </li>
      <li>
        <br />
        <app-language-selector [inline]="true" [dropUp]="true"></app-language-selector>
      </li>
    </ul>
  </div>
</div>
